<template>
  <div class="details-admin">
    <div class="admin-message">
      请到管理员后台进行操作
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailsAdmin",
  meta: {
    title: "管理员提示"
  }
};
</script>

<style scoped>
.details-admin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.admin-message {
  font-size: 18px;
  color: #333;
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 90%;
}
</style> 